export enum LabIds {
  PPL = 2,
  ALVERNO = 14,
  DEMO = 3,
}
